import {Component} from '@angular/core';
import {NgControl} from '@angular/forms';
import {AbstractInput} from '../../abstracts/abstract-input';

@Component({
  selector: 'app-input-text',
  templateUrl: '../input-base/input-base.component.html'
})
export class InputTextComponent extends AbstractInput {
  constructor(public ngControl: NgControl) {
    super(ngControl);
  }
}
